import { motion } from "framer-motion";

export default function Nav() {
  return (
    <motion.header
      initial={{ opacity: 0, y: -12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, delay: 0.2 }}
      className="absolute inset-x-0 top-0 z-40 flex items-center justify-between px-6 py-6 md:px-12"
    >
      <p className="font-serif text-lg leading-none" data-testid="nav-brand">
        Mírian Barcos
      </p>
      <div className="flex items-center gap-6 text-xs uppercase tracking-[0.2em] text-mirian-wine/60">
        <span className="hidden md:inline">Candidatura · Impacto Marketing</span>
        <a
          data-testid="nav-contact-link"
          href="mailto:mbarcosdearaujo@gmail.com"
          className="border-b border-mirian-wine/40 pb-0.5 text-mirian-wine transition-colors duration-300 hover:border-mirian-wine"
        >
          Hablemos
        </a>
      </div>
    </motion.header>
  );
}
